import React from 'react';

interface PendingApprovalBannerProps {
    userType: 'teacher' | 'consultant';
}

export const PendingApprovalBanner: React.FC<PendingApprovalBannerProps> = ({ userType }) => {
    return (
        <div className="fixed inset-0 z-40 pointer-events-none">
            {/* Top Banner */}
            <div className="absolute top-0 left-0 right-0 bg-amber-500 text-amber-900 py-3 px-4 text-center font-bold pointer-events-auto">
                <div className="flex items-center justify-center gap-2">
                    <svg className="w-5 h-5 animate-pulse" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                    <span>
                        Hesabınız yönetici onayı bekliyor. Onaylandıktan sonra tüm özelliklere erişebileceksiniz.
                    </span>
                </div>
            </div>

            {/* Overlay to disable interactions */}
            <div className="absolute inset-0 bg-slate-900/30 backdrop-blur-[1px] pointer-events-auto mt-12">
                <div className="flex items-center justify-center h-full">
                    <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl p-8 max-w-md mx-4 text-center">
                        <div className="w-20 h-20 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-6">
                            <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </div>
                        <h2 className="text-2xl font-bold text-white mb-4">Onay Bekleniyor</h2>
                        <p className="text-white/70 mb-6">
                            {userType === 'teacher'
                                ? 'Öğretmen hesabınız yönetici tarafından inceleniyor. Onaylandığında tüm özelliklere erişebileceksiniz.'
                                : 'Danışman hesabınız yönetici tarafından inceleniyor. Onaylandığında öğrenci atamalarını alabileceksiniz.'
                            }
                        </p>
                        <div className="flex items-center justify-center gap-2 text-amber-300">
                            <div className="w-2 h-2 bg-amber-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
                            <div className="w-2 h-2 bg-amber-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
                            <div className="w-2 h-2 bg-amber-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
